import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'

import '@/assets/styles/reset.scss'
import { Notify, Dialog, Picker, Popup, Tag, Icon, NoticeBar, Toast } from 'vant'
import vueTouch from "vue-plugin-touch"
import touch from 'vue-directive-touch'
import VueI18n from 'vue-i18n'
import 'lib-flexible'
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
Vue.use(Notify).use(Dialog).use(Picker).use(Popup).use(Tag).use(vueTouch).use(Icon).use(NoticeBar).use(Toast).use(touch).use(VueI18n);

// 初始化语言设置，确保默认为日语
const getInitialLocale = () => {
  const savedLang = localStorage.getItem("lang");
  if (savedLang) {
    // 将后端语言代码转换为前端VueI18n语言代码
    if (savedLang === 'en_us') return 'en';
    if (savedLang === 'ja_jp') return 'ja';
    if (savedLang === 'ko_kr') return 'ko';

	
    return savedLang; // zh_hk 保持不变
	
  } else {
    // 如果没有保存的语言，设置默认日语
    localStorage.setItem("lang", "zh_hk");
    return "zh_hk";
  }
};

const i18n = new VueI18n({
  locale: getInitialLocale(), // 使用函数确保正确的语言初始化
  messages: {
    'en': require('./assets/languages/en_US.json'),     // 英文
    'zh_hk': require('./assets/languages/zh_HK.json'),  // 繁体中文
    'ja': require('./assets/languages/ja_JP.json'),     // 日文
    'ko': require('./assets/languages/ko_KR.json'),      // 韩文
	'th_th': require('./assets/languages/th_TH.json'),
	'vi_vn': require('./assets/languages/vi_VN.json'),
	'ms_my': require('./assets/languages/ms_MY.json'),
	'pt_br': require('./assets/languages/pt_BR.json')
  }
});

console.log('main.js: VueI18n初始化完成，当前语言:', i18n.locale, 'localStorage语言:', localStorage.getItem("lang"));
Vue.config.productionTip = false;
Vue.prototype.utils_moneyMark = function () {
  return localStorage.getItem('moneyMark');
}
Vue.prototype.showcover = false;
let g_country = ["Angola", "Afghanistan", "Albania", "Algeria", "Andorra", "Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Ascension", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda Is.", "Bolivia", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina-faso", "Burma", "Burundi", "Cameroon", "Canada", "Cayman Is.", "Central African Republic", "Chad", "Chile", "中国", "Colombia", "Congo", "Cook Is.", "Costa Rica", "Cuba", "Cyprus", "Czech", "Denmark", "Djibouti", "Dominica Rep.", "Ecuador", "Egypt", "EI Salvador", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "French Guiana", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Grenada", "Guam", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "中国香港", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kampuchea （Cambodia）", "Kazakstan", "Kenya", "Korea", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "中国澳门", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mariana Is.", "Martinique", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montserrat Is.", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netheriands Antilles", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan", "Panama", "Papua New Cuinea", "Paraguay", "Peru", "Philippines", "Poland", "French Polynesia", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Saint Lueia", "Saint Vincent", "Samoa Eastern", "Samoa Western", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Is.", "Somali", "South Africa", "Spain", "Sri Lanka", "St.Lucia", "St.Vincent", "Sudan", "South Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "中国台湾", "Tajikstan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kiongdom", "United States of America", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Yemen", "Yugoslavia", "Zimbabwe", "Congo-kinshasa", "Zambia"];
let g_countryCode = [244, 93, 355, 213, 376, 1264, 1268, 54, 374, 247, 61, 43, 994, 1242, 973, 880, 1246, 375, 32, 501, 229, 1441, 591, 267, 55, 673, 359, 226, 95, 257, 237, 1, 1345, 236, 235, 56, 86, 57, 242, 682, 506, 53, 357, 420, 45, 253, 1890, 593, 20, 503, 372, 251, 679, 358, 33, 594, 241, 220, 995, 49, 233, 350, 30, 1809, 1671, 502, 224, 592, 509, 504, 852, 36, 354, 91, 62, 98, 964, 353, 972, 39, 225, 1876, 81, 962, 855, 327, 254, 82, 965, 331, 856, 371, 961, 266, 231, 218, 423, 370, 352, 853, 261, 265, 60, 960, 223, 356, 1670, 596, 230, 52, 373, 377, 976, 1664, 212, 258, 264, 674, 977, 599, 31, 64, 505, 227, 234, 850, 47, 968, 92, 507, 675, 595, 51, 63, 48, 689, 351, 1787, 974, 262, 40, 7, 1758, 1784, 684, 685, 378, 239, 966, 221, 248, 232, 65, 421, 386, 677, 252, 27, 34, 94, 1758, 1784, 249, 211, 597, 268, 46, 41, 963, 886, 992, 255, 66, 228, 676, 1809, 216, 90, 993, 256, 380, 971, 44, 1, 598, 233, 58, 84, 967, 381, 263, 243, 260];
for (const gCountryKey in g_country) {
  g_country[gCountryKey] = g_country[gCountryKey] + `(+${g_countryCode[gCountryKey]})`;
}
Vue.prototype.g_countryCode = g_countryCode
Vue.prototype.g_country = g_country;

window.vm = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
